(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    var moneyFormat = drawer.dataset.moneyFormat || '';
    var amountPattern = new RegExp('\\{\\{\\s*amount[^}]*\\}\\}');

    function formatMoney(cents) {
      var value = (cents / 100).toFixed(2);
      if (!moneyFormat) return value;
      return moneyFormat.replace(amountPattern, value);
    }

    function open() {
      if (drawer.open) return;
      if (typeof drawer.showModal === 'function') {
        drawer.showModal();
      } else {
        drawer.setAttribute('open', '');
      }
      /*
        Force a synchronous reflow so the browser commits the element's
        starting transform (translateX(-100%)) before we add the class that
        transitions it to translateX(0). Without this the browser may batch
        both changes into a single paint and skip the transition entirely.
      */
      drawer.getBoundingClientRect();
      drawer.classList.add('cart-drawer--is-open');

      /*
        showModal()'s native "dialog focusing steps" auto-focus the first
        focusable descendant — the close button — the instant the dialog
        opens. Several browsers' :focus-visible heuristics treat that
        programmatic auto-focus as keyboard-like and draw a ring even though
        nothing was tabbed to, so the close button shows a focus outline
        right after a plain tap/click open. Redirecting focus to the dialog
        itself keeps focus correctly inside the modal (still announced via
        aria-label for screen readers) without landing it on a control that
        gets a visible ring — .cart-drawer:focus is already outline:none
        below, so this needs no extra CSS. Real keyboard users tabbing
        afterward still get a normal, correctly-shown ring on whatever they
        land on.
      */
      drawer.focus({ preventScroll: true });
    }

    function close() {
      if (!drawer.open) return;
      /*
        Remove the open class first — the existing transition on .cart-drawer
        plays in reverse (translateX(0) → translateX(-100%)) and the backdrop
        opacity fades from 1 → 0 in sync. Once the transform finishes we call
        drawer.close() so the UA removes [open] and tears down the backdrop.

        A timeout fallback guards against transitionend not firing (e.g. if
        prefers-reduced-motion disables transitions at the OS level).
      */
      drawer.classList.remove('cart-drawer--is-open');

      var finished = false;
      function finish() {
        if (finished) return;
        finished = true;
        drawer.removeEventListener('transitionend', onTransitionEnd);
        drawer.close();
      }

      var fallback = setTimeout(finish, 400);

      function onTransitionEnd(e) {
        if (e.target !== drawer || e.propertyName !== 'transform') return;
        clearTimeout(fallback);
        finish();
      }

      drawer.addEventListener('transitionend', onTransitionEnd);
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-cart-drawer-toggle]');
      if (trigger) {
        event.preventDefault();
        open();
        return;
      }

      var closer = event.target.closest('[data-cart-drawer-close]');
      if (closer) {
        event.preventDefault();
        close();
        return;
      }
    });

    drawer.addEventListener('click', function (event) {
      if (event.target === drawer) close();
    });

    drawer.addEventListener('cancel', function (event) {
      event.preventDefault();
      close();
    });

    function refresh(state) {
      var totals = drawer.querySelector('[data-cart-totals]');
      var totalDisplay = drawer.querySelector('[data-cart-total]');
      if (totalDisplay) totalDisplay.textContent = formatMoney(state.total_price);
      if (totals) {
        if (state.item_count === 0) totals.setAttribute('hidden', '');
        else totals.removeAttribute('hidden');
      }

      var bagLinks = document.querySelectorAll('[data-bag-count]');
      bagLinks.forEach(function (el) {
        el.textContent = state.item_count;
      });
    }

    function escapeAttr(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }

    function escapeHtml(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }

    function lower(value) {
      return String(value == null ? '' : value).toLowerCase();
    }

    function sizedImage(url, width) {
      if (!url) return '';
      return url.replace(/(\.(?:jpg|jpeg|png|gif|webp))(\?|$)/i, '_' + width + 'x$1$2');
    }

    function renderItems(state) {
      var list = drawer.querySelector('[data-cart-items]');
      if (!list) return;

      if (!state.items || state.item_count === 0) {
        var empty = document.createElement('p');
        empty.className = 'cart-drawer__empty';
        empty.textContent = drawer.dataset.emptyLabel || '';
        list.innerHTML = '';
        list.appendChild(empty);
        return;
      }

      var removeLabel = drawer.dataset.removeLabel || '';
      var decLabel = drawer.dataset.decreaseLabel || '';
      var incLabel = drawer.dataset.increaseLabel || '';

      list.innerHTML = state.items
        .map(function (line) {
          var title = lower(line.product_title);
          if (!line.product_has_only_default_variant && line.variant_title) {
            title += ', ' + lower(line.variant_title);
          }
          var url = escapeAttr(line.url);
          var media = line.image
            ? '<img src="' + escapeAttr(sizedImage(line.image, 480)) + '" alt="' + escapeAttr(lower(line.product_title)) + '" loading="lazy">'
            : '';

          return (
            '<article class="cart-item" data-cart-item data-key="' + escapeAttr(line.key) + '">' +
              '<a href="' + url + '" class="cart-item__media" tabindex="-1" aria-hidden="true">' + media + '</a>' +
              '<div class="cart-item__body">' +
                '<div class="cart-item__row">' +
                  '<div class="cart-item__text">' +
                    '<p class="cart-item__title"><a href="' + url + '">' + escapeHtml(title) + '</a></p>' +
                    '<p class="cart-item__price" data-cart-item-price>' + formatMoney(line.final_line_price) + '</p>' +
                  '</div>' +
                  '<div class="cart-item__qty" role="group">' +
                    '<button type="button" class="cart-item__qty-btn" data-cart-qty="dec" aria-label="' + escapeAttr(decLabel) + '">–</button>' +
                    '<span class="cart-item__qty-value" data-cart-qty-display>' + line.quantity + '</span>' +
                    '<button type="button" class="cart-item__qty-btn" data-cart-qty="inc" aria-label="' + escapeAttr(incLabel) + '">+</button>' +
                  '</div>' +
                '</div>' +
                '<button type="button" class="cart-item__remove" data-cart-remove>' + escapeHtml(removeLabel) + '</button>' +
              '</div>' +
            '</article>'
          );
        })
        .join('');
    }

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('form[action*="/cart/add"]');
      if (!form) return;

      event.preventDefault();
      var submitBtn = form.querySelector('[name="add"]');
      if (submitBtn) submitBtn.setAttribute('disabled', '');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          return fetch('/cart.js', { headers: { Accept: 'application/json' } });
        })
        .then(function (r) { return r.json(); })
        .then(function (state) {
          renderItems(state);
          refresh(state);
          open();
        })
        .catch(function () {
          form.submit();
        })
        .finally(function () {
          if (submitBtn) submitBtn.removeAttribute('disabled');
        });
    });

    function updateLine(item, quantity) {
      var key = item.dataset.key;
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity }),
      })
        .then(function (r) { return r.json(); })
        .then(function (state) {
          if (quantity === 0) {
            item.remove();
            if (state.item_count === 0) {
              var list = drawer.querySelector('[data-cart-items]');
              if (list) {
                var p = document.createElement('p');
                p.className = 'cart-drawer__empty';
                p.textContent = drawer.dataset.emptyLabel || '';
                list.innerHTML = '';
                list.appendChild(p);
              }
            }
          } else {
            var display = item.querySelector('[data-cart-qty-display]');
            var price = item.querySelector('[data-cart-item-price]');
            var line = (state.items || []).filter(function (li) { return String(li.key) === String(key); })[0];
            if (display && line) display.textContent = line.quantity;
            if (price && line) price.textContent = formatMoney(line.final_line_price);
          }
          refresh(state);
        });
    }

    drawer.addEventListener('click', function (event) {
      var item = event.target.closest('[data-cart-item]');
      if (!item) return;

      var qtyBtn = event.target.closest('[data-cart-qty]');
      if (qtyBtn) {
        var display = item.querySelector('[data-cart-qty-display]');
        var current = parseInt(display.textContent, 10) || 0;
        var next = qtyBtn.dataset.cartQty === 'inc' ? current + 1 : Math.max(0, current - 1);
        updateLine(item, next);
        return;
      }

      var rm = event.target.closest('[data-cart-remove]');
      if (rm) {
        updateLine(item, 0);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["site-nav"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.menu-drawer').forEach(function (drawer) {
    var summary = drawer.querySelector(':scope > summary.menu-drawer__toggle');
    var panel = drawer.querySelector('.menu-drawer__panel');

    function closeDrawer() {
      if (!drawer.open) return;
      // If no animation is playing (e.g. prefers-reduced-motion), close immediately.
      if (!panel || getComputedStyle(panel).animationName === 'none') {
        drawer.removeAttribute('open');
        return;
      }

      drawer.classList.add('is-closing');

      var finished = false;
      function finish() {
        if (finished) return;
        finished = true;
        panel.removeEventListener('animationend', onAnimationEnd);
        drawer.classList.remove('is-closing');
        drawer.removeAttribute('open');
      }

      /*
        FIX: fallback in case animationend never fires (interrupted
        animation, unexpected browser quirk, etc.) so the drawer can't get
        stuck open with .is-closing applied forever — mirrors the same
        safeguard added to the cart drawer's close().
      */
      var fallback = setTimeout(finish, 400);

      function onAnimationEnd(event) {
        if (event.target !== panel) return;
        clearTimeout(fallback);
        finish();
      }

      panel.addEventListener('animationend', onAnimationEnd);
    }

    /*
      FIX: clicking the toggle while the drawer is open previously let the
      browser's native <details> behavior remove [open] instantly, skipping
      closeDrawer() and its exit animation entirely — the toggle is exactly
      how most people close the menu, so the close animation effectively
      never played in normal use. Opening is left to the native default
      (harmless, since the "in" animation is a keyframe animation and plays
      correctly the moment [open] is applied); only the closing half is
      intercepted and routed through the animated path.
    */
    if (summary) {
      summary.addEventListener('click', function (event) {
        if (drawer.open) {
          event.preventDefault();
          closeDrawer();
        }
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.open) {
        closeDrawer();
      }
    });

    document.addEventListener('click', function (event) {
      if (drawer.open && !drawer.contains(event.target)) {
        closeDrawer();
      }
    });
  });

  document.querySelectorAll('.site-nav__back').forEach((link) => {
    const referrer = document.referrer;
    if (referrer) {
      try {
        const referrerHost = new URL(referrer).hostname;
        const currentHost = window.location.hostname;

        // same-site check (handles www./subdomain variants)
        if (referrerHost === currentHost || referrerHost.endsWith('.' + currentHost) || currentHost.endsWith('.' + referrerHost)) {
          link.addEventListener('click', (e) => {
            e.preventDefault();
            history.back();
          });
        }
      } catch (e) {
        // malformed referrer, fall through to static href
      }
    }
    // if referrer is empty or cross-domain, the anchor's real href just works as-is
  });
  } catch(e) { console.error(e); }
})();

})();
